import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./components/Auth/AuthContext";
import { HelmetProvider } from 'react-helmet-async';
import { ConsentProvider } from "./contexts/ConsentContext";


// Registrar el Service Worker
/*
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        console.log("::Service Worker registrado correctamente:", registration);
      })
      .catch((error) => {
        console.error("Error al registrar el Service Worker:", error);
      });
  });
}
*/
/*
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    const now = new Date();
    
    // Redondear los minutos al múltiplo de 5 más cercano
    const minutes = Math.floor(now.getMinutes() / 5) * 5; 
    
    const version = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}-${String(now.getHours()).padStart(2, "0")}-${String(minutes).padStart(2, "0")}`;

    navigator.serviceWorker
      .register(`/service-worker.js?v=${version}`)
      .then(() => console.log(":::Service Worker registrado con versión:", version))
      .catch((error) => console.error("Error registrando SW:", error));
  });
}
*/

// Asegúrate de que el elemento root exista antes de crear el render
const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("No se encontró el elemento con id 'root'");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ConsentProvider>


        <AuthProvider>
          <App />
        </AuthProvider>
      </ConsentProvider>
    </HelmetProvider>

  </React.StrictMode>
);

// Medir el rendimiento de la aplicación
reportWebVitals();
